import * as React from "react";
import { Form, Formik, useField } from "formik";
import * as Yup from "yup";
import { Autocomplete, Button, TextField } from "@mui/material";
import { ButtonsContainer, FieldContainer, FormContainer, SectionContainer, SectionTitle } from "./ClassesForm.styled";
import InputField from "../../../../components/formFields/InputField";
import DatePickerField from "../../../../shared/components/DatePickerField";
import { useCreateAssessmentClassAMutation, useGetNaicMemberQuery, useUpdateAssessmentClassAMutation } from "../../../../services/InsuranceService";
import dayjs from "dayjs";
import SearchableSelect from "../../../../components/formFields/SearchableSelect";
import { LoadingPanel } from "../../../../shared/components/LoadingPanel";

const ClassAForm = (props) => {
  const { onClose, data } = props;

  const currentYear = new Date().getFullYear();

  const transformedData = {...data, amount: data?.adminAmount}
  const initialValues = data ? transformedData : {
    naicCode: "",
    premiumYear: currentYear.toString(),
    title: `Class A - ${currentYear}`,
    amount: "",
    comments: "",
  };

  const [createAssesmentClassA, {isLoading: isAssesmentCreating}] = useCreateAssessmentClassAMutation("");
  const [updateAssesmentClassA, {isLoading: isAssesmentUpdating}] = useUpdateAssessmentClassAMutation("");

  const { data: naicMembers, isLoading } = useGetNaicMemberQuery('', {});

  const validationSchema = Yup.object().shape({
    // premiumYear: Yup.string().required("Premium Year is required"),
    // title: Yup.string().required("Title is required"),
    // amount: Yup.number().required("Amount is required"),
  });

  const handleSubmit = (values) => {
    !data ? createAssesmentClassA({
      memberId: values.naicCode?.id === 0 ? 0 : values.naicCode?.id,
      naicCode: values.naicCode?.naicCode,
      premiumYear: dayjs(values.premiumYear).year().toString(),
      amount: Number(values.amount),
      title: values.title,
      comments: values.comments,
    }) : updateAssesmentClassA({
      id: transformedData?.id,
      memberId: values.naicCode?.id === 0 ? 0 : values.naicCode?.id,
      naicCode: values.naicCode?.naicCode,
      premiumYear: dayjs(values.premiumYear).year().toString(),
      amount: Number(values.amount),
      title: values.title,
      comments: values.comments,
    })
    onClose()
  };

  const getInputComponent = (item) => {
    switch (item?.type) {
      case "text":
        return (
          <FieldContainer>
            <InputField
              name={item.name}
              label={item.label}
              fullWidth
            />
          </FieldContainer>
        );
      case "number":
        return (
          <FieldContainer>
            <InputField
              name={item.name}
              label={item.label}
              fullWidth
              mode="decimal"
            />
          </FieldContainer>
        );
      case "multiline":
        return (
          <FieldContainer>
            <InputField
              name={item.name}
              label={item.label}
              fullWidth
              multiline
              rows={item.rows}
            />
          </FieldContainer>
        );
      case "date":
        return (
              <FieldContainer>
                <DatePickerField
                  name={item.name}
                  label={item.label}
                  maxDate={new Date()}
                  width={"100%"}
                  isYearSelect
                  // disabled
                />
              </FieldContainer>
        );
      case "searchableSelect":
        return (
              <FieldContainer>
                <SearchableSelect
                  name={item.name}
                  label={item.label}
                  fullWidth
                  multiline
                  options={naicMembers}
                  isDisabled={!!data}
                />
              </FieldContainer>
        );
      default:
        return null;
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {({ values, handleChange }) => (
        <Form>
          {isLoading || isAssesmentCreating || isAssesmentUpdating && <LoadingPanel />}
          <FormContainer>
            <SectionContainer>
              {getInputComponent({
                name: "naicCode",
                label: "NAIC Code:",
                type: "searchableSelect",
              })}

              {getInputComponent({
                name: "premiumYear",
                label: "Premium Year:",
                type: "date",
              })}

              {getInputComponent({
                name: "title",
                label: "Title:",
                type: "text",
              })}

              {getInputComponent({
                name: "amount",
                label: "Amount:",
                type: "number",
              })}

              {getInputComponent({
                name: "comments",
                label: "Comments:",
                type: "text",
                rows: 4,
              })}

              <ButtonsContainer>
                <Button variant="outlined" type="submit">
                  {`${data ? 'Edit' : 'Create'} Assessment`}
                </Button>
                <Button variant="outlined" type="reset" onClick={onClose}>
                  Cancel
                </Button>
              </ButtonsContainer>
            </SectionContainer>
          </FormContainer>
        </Form>
      )}
    </Formik>
  );
};

export default ClassAForm;
